/* eslint-disable react/jsx-no-undef */
import React from "react";
import Container from "@mui/material/Container";
import TextField from "@mui/material/TextField";
import registerStep3 from '../../assets/images/register/register-step-3-3.svg';
import member from "../../assets/images/register/member.svg";
import dayjs from "dayjs";
import Stack from "@mui/material/Stack";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import SecondaryButton from "../../components/button/SecondaryButton";
import PrimaryButton from "../../components/button/PrimaryButton";
import TopBanner from '../../components/layout/TopBanner';
import { setRegisterMain } from '../../features/register/RegisterMainSlice';
import { useDispatch, useSelector } from 'react-redux';
import TopLogo from '../../components/layout/TopLogo';
import globalStyle from "../../assets/styles/constants";
import { Checkbox, Radio } from "@mui/material";
import { useLiff } from 'react-liff';
import { SearchQuestionnaireById, CreateUserAnswer } from "../../services/Questionnaire";
import helper from "../../functions/helper";
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from "@mui/material/FormControlLabel";
import { Controller } from "react-hook-form";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import FormHelperText from '@mui/material/FormHelperText';

export default function QuestionnairePreview() {
    // lineId
    let { qId } = useParams();
    const [quizId, setQuizId] = React.useState(0)
    const [quizName, setQuizName] = React.useState('')
    const [quizNo, setQuizNo] = React.useState(0)
    const [quizList, setQuizList] = React.useState([])
    const [ansList, setAnsList] = React.useState({})
    const [sumPoint, setSumPoint] = React.useState({})

    const store = useSelector((state) => state.registerMain)

    const dispatch = useDispatch()
    const navigate = useNavigate();

    const { register, formState: { errors }, handleSubmit, control, watch } = useForm({
        defaultValues: {
        }
    });

    function fnSetData(name, value) {
        const tmpObj = {};
        tmpObj[name] = value;
        dispatch(setRegisterMain(tmpObj));
    }

    React.useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name && type) {
                fnSetData(name, value[name]);
            }
        });
        return () => subscription.unsubscribe();
    }, [watch]);

    async function getSearchQuestionnaire() {
        return await SearchQuestionnaireById({ params: { id: qId } })
            .then(async (res) => {
                const resData = res.data
                if (resData.resultCode == 20000) {
                    setQuizId(resData.body.questionnaire[0]?.questionnaireId)
                    setQuizNo(resData.body.questionnaire[0]?.questionnaireNo)
                    setQuizName(resData.body.questionnaire[0]?.questionnaireName)
                    setSumPoint(resData.body.questionnaire[0]?.point ?? 0)
                    setQuizList(resData.body.questionnaire[0]?.questionnaireQuestion)
                    // setMemberId(resData.memberId)
                } else if (resData.resultCode == 40400) {
                    // fnSetData('memberId', null)
                    // fnSetData('points', 0)
                    // fnSetData('payload', {})
                    // navigate('/questionnaire-not-found')
                    // window.localStorage.setItem('p', btoa(JSON.stringify(ans)))
                    // window.localStorage.setItem('p', helper.encodeJWT(ans))
                    //   window.location.replace('/questionnaire-not-found')
                } else {
                    // fnSetData('memberId', null)
                    // fnSetData('points', 0)
                    // fnSetData('payload', {})
                    // navigate('/questionnaire-success')
                    // let ans = { memberId: null, points: 0, payload: {} }
                    // window.localStorage.setItem('p', btoa(JSON.stringify(ans)))
                    // window.localStorage.setItem('p', helper.encodeJWT(ans))
                    navigate('/register-success')
                }

            })
            .catch((error) => {
                console.log(error);
            });
    }

    const handleChange = (value, name, type) => {
        let _ansList = { ...ansList }
        if (_ansList[name]) {
            if (type === 1 || type === 4) {
                _ansList[name] = value
            }
            else if (type === 3) {
                if (value) {
                    _ansList[name] = value
                } else {
                    delete _ansList[name]
                }
            }
            else {
                if (Array.isArray(_ansList[name]) && _ansList[name].includes(value)) {
                    _ansList[name] = _ansList[name].filter(item => item !== value)
                    if (_ansList[name].length === 0) {
                        delete _ansList[name]
                    }
                } else {
                    _ansList[name].push(value)
                }
            }
        } else {
            if (type === 1) {
                _ansList[name] = value
            }
            else if (type === 3) {
                _ansList[name] = value
            }
            else {
                _ansList[name] = [value]
            }
        }
        setAnsList(_ansList)
    };
    const ImageTitle = (urlPicture) => {
        return <>
            {
                urlPicture ? (
                    <img
                        className="w-full h-[158px] object-cover mb-[12px] rounded-[5px]"
                        src={urlPicture}
                        alt=""
                    />
                ) : (
                    <></>
                )
            }
        </>
    }
    const ImageChoice = (urlPicture) => {
        return <>
            {
                urlPicture ? (
                    <img
                        className="w-full h-[148px] object-cover mb-[12px] rounded-[5px] ml-[15px]"
                        src={urlPicture}
                        alt=""
                    />
                ) : (
                    <></>
                )
            }
        </>
    }


    const ansToPayload = (ans = {}, quiz_id, line_id = 0) => {
        let questionnaireQuestion = []

        for (const k in ans) {
            let tmp = {
                questionnaireQuestionId: k,
                questionnaireAnswerId: Array.isArray(ans[k]) ? ans[k] : [Number(ans[k])]
            }
            if (`${k}`.endsWith('|3')) {
                const subId = `${k}`.replace('|3', '')
                tmp = {
                    questionnaireQuestionId: subId,
                    answerText: ans[k]
                }
            }
            questionnaireQuestion.push(tmp)
        }

        return {
            lineId: line_id,
            questionnaireId: quiz_id,
            questionnaireQuestion: questionnaireQuestion,
        }
    }

    React.useEffect(() => {
        getSearchQuestionnaire()
    }, []);


    return (
        <div className="w-[400px] mx-auto">
            <form autoComplete="off">
                <TopLogo />
                <TopBanner type="register" />
                <div maxWidth="xl" className="mt-[-20px]">
                    <div className="bg-white px-3">
                        <img src={registerStep3} alt="logo" style={{ width: "100%" }} />
                        <div style={{ fontSize: 30, textAlign: "center" }}>
                            ลงทะเบียนสำหรับ
                            <span style={{ fontWeight: "bold" }}> ผู้ใช้งานทั่วไป</span>
                        </div>
                        <div style={{ textAlign: "center" }}>
                            <img
                                src={member}
                                alt="logo"
                                style={{ width: "20%", display: "initial" }}
                            />
                        </div>
                        <div style={{ padding: "0 10px" }}>
                            <div className="flex gap-[10px] justify-start">
                                <div className="primary-color title-size">ตอบคำถาม</div>
                                <div style={{ marginTop: "6px" }}>
                                    <p className="sub-title-size">Survey</p>
                                    <div className="blue-line" ></div>
                                </div>
                            </div>

                            {quizList.map((item, i) => {
                                const no = (i + 1)
                                if (item.answerType === 1 && item.displayType === 1) {
                                    return (
                                        <div key={i}>
                                            {ImageTitle(item.urlPicture)}
                                            <h2 className="text-header2 text-left">ข้อที่ {no} : {item.question}</h2>
                                            <div className="px-[12px]">
                                                <RadioGroup
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    defaultValue="female"
                                                    name="radio-buttons-group"
                                                    onChange={(e) => handleChange(e.target.value, item.questionnaireQuestionId, 1)}
                                                >
                                                    {item.questionnaireAnswer.map((choice, i2) => {
                                                        return (
                                                            <>
                                                                <FormControlLabel key={'A' + i2} value={choice.questionnaireAnswerId} control={<Radio />} label={choice.answer} />
                                                                {ImageChoice(choice.urlPicture)}
                                                            </>
                                                        )
                                                    })}
                                                </RadioGroup>
                                            </div>
                                        </div>
                                    )
                                }
                                if (item.answerType === 1 && item.displayType === 2) {
                                    return (
                                        <div className="mb-[5px]" key={i}>
                                            {ImageTitle(item.urlPicture)}
                                            <h2 className="text-header2 text-left">ข้อที่ {no} : {item.question}</h2>
                                            <div className="pr-[12px] mb-[10px]" >
                                                <FormControl fullWidth>
                                                    <Select
                                                        defaultValue='none'
                                                        displayEmpty
                                                        onChange={(e) => handleChange(e.target.value, item.questionnaireQuestionId, 4)}
                                                        inputProps={{ 'aria-label': 'Without label' }}
                                                    >
                                                        <MenuItem selected={true} disabled value="none" style={{ color: "#8F8F8F" }}>
                                                            <p style={{ color: "#8F8F8F" }}>เลือกคำตอบ</p>
                                                        </MenuItem>
                                                        {item.questionnaireAnswer.map((item, i) => (
                                                            <MenuItem value={item.questionnaireAnswerId} key={i}>
                                                                {item.answer}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </div>
                                        </div>
                                    )
                                }
                                if (item.answerType === 2) {
                                    return (
                                        <div key={'B' + i}>
                                            {ImageTitle(item.urlPicture)}
                                            <h2 className="text-header2 text-left">ข้อที่ {no} : {item.question}</h2>
                                            <h3 className="text-content text-left mt-[-10px] secondary-color">(เลือกตอบได้มากกว่า 1 ข้อ)</h3>
                                            <div className="px-[12px]">
                                                {item.questionnaireAnswer.map((choice, i2) => {
                                                    const isChecked = (ansArr = [], cur) => {
                                                        return Array.isArray(ansArr) && ansArr.includes(cur)
                                                    }
                                                    return (
                                                        <>
                                                            <FormControlLabel key={'B' + i2} sx={{ display: "block" }} control={
                                                                <Checkbox checked={isChecked(ansList[`${item.questionnaireQuestionId}`], choice.questionnaireAnswerId)}
                                                                    onChange={(e) => handleChange(choice.questionnaireAnswerId, item.questionnaireQuestionId, 2)} />
                                                            } label={choice.answer} />
                                                            {ImageChoice(choice.urlPicture)}
                                                        </>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    )
                                }
                                if (item.answerType === 3) {
                                    return (
                                        <div key={'B' + i}>
                                            {ImageTitle(item.urlPicture)}
                                            <h2 className="text-header2 text-left">ข้อที่ {no} : {item.question}</h2>
                                            <h3 className="text-content text-left mt-[-10px] secondary-color">(กรอกได้ไม่เกิน 255 ตัวอักษร)</h3>
                                            {/* {ansList[`${item.questionnaireQuestionId}|3`]} */}
                                            <div className="px-[12px]">
                                                <div className="flex flex-col gap-[0px] mt-[24px]">
                                                    {/* <p className="text-[24px] text-left">บันทึกประจำวัน</p> */}
                                                    <TextField
                                                        style={{ height: "auto" }}
                                                        className="w-full text-[20px] border border-indigo-600 text-area"
                                                        value={ansList[`${item.questionnaireQuestionId}|3`]}
                                                        multiline
                                                        rows={3}
                                                        label=""
                                                        onChange={(event) => {
                                                            let txt = event.target?.value == '' ? undefined : event.target?.value
                                                            if (txt) {
                                                                txt = txt.substring(0, 255)
                                                            }
                                                            handleChange(txt, item.questionnaireQuestionId + '|' + 3, 3)
                                                        }}
                                                        variant="standard"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                return '-'
                            })}

                            <br></br>
                        </div>
                    </div>
                </div>
                <div className="bg-white mt-[20px] h-[100px] pt-[25px]">
                    <Stack
                        spacing={2}
                        direction="row"
                        alignItems="center"
                        justifyContent="center"
                    >
                        <SecondaryButton variant="outlined" className="w-[40%]">
                            ย้อนกลับ
                        </SecondaryButton>
                        <PrimaryButton variant="contained" className="w-[40%]"
                            disabled={Object.keys(ansList).length == 0 || Object.keys(ansList).length !== quizList.length}>
                            ต่อไป
                        </PrimaryButton>
                    </Stack>
                </div>
            </form >
        </div>
    );
}
